// extracted by mini-css-extract-plugin
export default {"FilterIcon":"edit-filter-button__FilterIcon___VAxh7"};